import { UpgradeCheckoutState } from '~/components/upgrade/types';

export default {
  checkout: {
    title: {
      [UpgradeCheckoutState.Default]: 'Upgrade',
      [UpgradeCheckoutState.AddOns]: 'Add-On Upgrade',
      [UpgradeCheckoutState.Renew]: 'Renew',
      [UpgradeCheckoutState.AddEvents]: 'Add Events',
    },
    need_help: 'Need help?',
    per_event: '/ Event',
    contact_us: {
      title: 'Not sure which options is best for you?',
      subtitle: 'Contact us to ask questions, and chat about your needs.',
      cta: 'Contact Us',
      url: 'https://meetings.hubspot.com/matt193/in-app',
    },
    cost: 'Cost',
    active_event:
      '*Unlimited unpublished events. Only active or published events count towards your limit.<br/>Once an event has ended, it no longer counts towards your limit.',
    pay_now: 'Pay Now',
    update_plan: 'Update Plan',
    confirm: 'Confirm',
    renew_alert:
      'Your changes will be applied starting with the next billing cycle on {date}, after your current plan ends.',
    programmed_alert:
      'A renewal is currently scheduled for {date}. If you upgrade your plan, this renewal will be canceled.',
    pay_now_waiting: 'Processing',
    empty_cart: 'Your cart is empty.',
    explore_notice: 'You can also benefit from a higher submission limit by upgrading your current plan.',
    explore_cta: 'Explore Event Upgrades',
    org_billing_info: {
      title: 'Billing Information',
      purchase_number: 'Purchase Order Number',
    },
    packages: {
      progress_title: 'Tier',
      per_event: 'Per active event*, billed yearly',
      fee: 'Transaction Fee',
      fee_custom: '% Transaction Fee',
      select: 'Select Tier',
      selected: 'Selected',
      current: 'Current Tier',
      downgrade: "You can't downgrade from current tier.",
      hint: 'Please note that your payment processor fee will also apply on top of this.',
    },
    add_ons: {
      progress_title: 'Add-Ons',
      per_event: '/ Event',
      select: 'Select Add-On',
      purchased: 'Already Purchased',
      included: 'Included in selected package',
    },
    max_event_select: {
      label: 'Number of Events',
      discount: '(Save 10%)',
      hint: "Represents the number of concurrent active events allowed, that is, any published event that hasn't ended yet.",
      help: 'For more than 10 events',
    },
    term_length: {
      label: 'Term Length',
      one_year: '1-year',
      two_year: '2-year',
      three_year: '3-year (Save 10%)',
      help: 'Choose the 3-year term and lock in your rate against any price increase.',
    },
    payment: {
      progress_title: 'Payment',
      title: 'Payment Method',
      credit_card: 'Credit Card',
      invoice: 'Invoicing',
      invoice_disable: 'This option is available for verified organizations. To verify your organization, contact',
      invoice_notice:
        'An invoice will be issued promptly and can be settled via check or bank transfer within 30 days. Detailed payment instructions will be provided on the invoice.',
      success: 'Your purchase has been completed successfully.',
      success_no_transactions: 'Your plan has been updated successfully.',
      renew_notice:
        'An invoice will be issued on the renewal date, and you’ll receive an email notification with options to pay online or by invoice.',
    },
    complete_payment_modal: {
      title: 'Complete Payment',
      price_difference_title: 'These items have changed in price since they were added to your cart:',
      price_difference_item: '{name} is now priced at {newCost}.',
      success: 'Your payment has been completed.',
      billing_method: 'Payment Method',
      summary: 'Summary',
    },
    error_modal: {
      missing_address: {
        title: 'Information Missing',
        subtitle: `Your organization's settings is missing a billing address. Please update this information before you purchase an upgrade.`,
        actionLabel: 'Go to Settings',
      },
      activate_account: {
        title: 'Activate your Account',
        subtitle:
          'You must first activate your Fourwaves account to proceed to the upgrade. Click on the link in the email sent to {email}.',
        actionLabel: 'Send Activation Email',
      },
    },
  },
};
